const adaptation = () => {
  // let bigWidth = screen.availWidth;
  // let bigWidth = window.innerWidth;
  let bigWidth = document.documentElement.clientWidth;
  let proportion = 0;
  let proportionBanner = 0;
  if (bigWidth < 1300) {
    proportion = bigWidth / 1300;
  } else {
    proportion = 0;
  }
  if (bigWidth < 1600) {
    proportionBanner = bigWidth / 1300;
  } else {
    proportionBanner = 0;
  }
  if(proportionBanner){
    let bannerId = document.querySelector("#bannerId");
    if(bannerId) bannerId.style.transformOrigin = "top left";
    if(bannerId) bannerId.style.transform = "scale(" + proportion + ")";

  }
  if (proportion) {
    let contentId = document.querySelector("#contentId");
    let topContentId = document.querySelector("#topContentId");
    let contactModel_id = document.querySelector("#contactModel_id");
    let root = document.querySelector("#root");
    if(contentId) contentId.style.transformOrigin = "top left";
    if(contentId) contentId.style.transform = "scale(" + proportion + ")";
    if(topContentId) topContentId.style.transformOrigin = "top left";
    if(topContentId) topContentId.style.transform = "scale(" + proportion + ")";
    if(contactModel_id) contactModel_id.style.transformOrigin = "top left";
    if(contactModel_id) contactModel_id.style.transform = "scale(" + proportion + ")";
    // contentId.style.overflowY='hidden'
    // let contentId = document.querySelector("#root");
    // if (contentId) contentId.style.transformOrigin = "top left";
    // if (contentId) contentId.style.transform = "scale(" + proportion + ")";
    // contentId.style.overflowY = "hidden";
  }
};
export { adaptation };
